/**
 * Passo a passo do método Lean Startup
 */

export const methodSteps = [
  {
    id: 'step-001',
    number: 1,
    labelKey: 'method.steps.0.label',
    titleKey: 'method.steps.0.title',
    descriptionKey: 'method.steps.0.description',
    icon: 'check-circle',
  },
  {
    id: 'step-002',
    number: 2,
    labelKey: 'method.steps.1.label',
    titleKey: 'method.steps.1.title',
    descriptionKey: 'method.steps.1.description',
    icon: 'lightbulb',
  },
  {
    id: 'step-003',
    number: 3,
    labelKey: 'method.steps.2.label',
    titleKey: 'method.steps.2.title',
    descriptionKey: 'method.steps.2.description',
    icon: 'refresh-cw',
  },
  {
    id: 'step-004',
    number: 4,
    labelKey: 'method.steps.3.label',
    titleKey: 'method.steps.3.title',
    descriptionKey: 'method.steps.3.description',
    icon: 'trending-up',
  },
];

export default methodSteps;
